<script setup lang="ts">
  import { computed } from 'vue'
  const props = defineProps({
    items: {
      type: Array<any>,
      required: true,
      default: () => [],
    },
    currentPage: {
      type: Number,
      required: true,
    },
    setting: {
      type: Object,
      default: () => {
        return {
          itemsPerPage: 10,
          maxPagination: 10,
        }
      },
    },
  })

  const emits = defineEmits(['update:currentPage'])

  const itemsPerPage = computed(() =>
    // Determine to show items list upon requested page.
    props.items.slice(
      (props.currentPage - 1) * props.setting.itemsPerPage,
      props.currentPage * props.setting.itemsPerPage
    )
  )
</script>
<template>
  <div class="pagination">
    <div class="pagination__list-items">
      <slot v-for="item in itemsPerPage" name="item" v-bind="item" />
    </div>
    <Pagination
      :current-page="currentPage"
      :items-per-page="setting.itemsPerPage"
      :max-pagination="setting.maxPagination"
      :total-count="items.length"
      @update:current-page="emits('update:currentPage', $event)"
    />
  </div>
</template>
<style scoped lang="scss">
  .pagination {
    width: 100%;
    margin: 0 auto;
  }
</style>
